export const formatMileage = (mileage: number) => {
  const miles = mileage.toString();

  if (mileage >= 1000) {
    const leadingNumbers = miles.slice(0, Math.floor(Math.log10(mileage)) - 2);

    return parseInt(leadingNumbers).toLocaleString() + (mileage >= 1000 ? 'k' : '') + ' mi';
  }

  return miles + ' mi';
};
